<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      门店管理
      <small>
        /&nbsp;
        <router-link to="/storelist" class="TitleStyle">门店列表</router-link>/&nbsp;门店列表详情
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">门店列表详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <span class="TInfo">基本信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent">
                        <span class="TCode">所属机构：</span>
                        <span class="TCodeContent">{{storeList.lesseeName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">大区：</span>
                        <span class="TCodeContent">{{storeList.firstAreaName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">分区：</span>
                        <span class="TCodeContent">{{storeList.secondAreaName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">区域：</span>
                        <span class="TCodeContent">{{storeList.thirdAreaName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">门店id：</span>
                        <span class="TCodeContent">{{storeList.shopId}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">门店编号：</span>
                        <span class="TCodeContent">{{storeList.shopCode}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">门店名称：</span>
                        <span class="TCodeContent">{{storeList.shopName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">店员数量：</span>
                        <span class="TCodeContent">{{storeList.shoperCount}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">老板：</span>
                        <span class="TCodeContent">{{storeList.bossName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">联系方式：</span>
                        <span class="TCodeContent">{{storeList.shoperTel}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">所在省：</span>
                        <span class="TCodeContent">{{storeList.province}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">所在市：</span>
                        <span class="TCodeContent">{{storeList.city}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">所在区：</span>
                        <span class="TCodeContent">{{storeList.district}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">详细地址：</span>
                        <span class="TCodeContent">{{storeList.address}}</span>
                      </li>
                      <li class="TableContent" v-if="storeList.lesseeId === 2">
                        <span class="TCode">推广人：</span>
                        <span class="TCodeContent">{{storeList.lesseePersonName + ' ' + storeList.lesseePersonCode}}</span>
                      </li>
                      <li class="clear"></li>
                    </ul>
                  </div>
                  <div class="GTitle">
                    <span class="TInfo">支付账户信息</span>
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">
                      <li class="TableContent">
                        <span class="TCode">账户类型：</span>
                        <span class="TCodeContent">{{
                            {
                              'P': '个人户',
                              'C': '公司户'
                            }[storeLists.bankType]
                          }}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">账户名称：</span>
                        <span class="TCodeContent">{{storeLists.trueName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">银行卡号：</span>
                        <span class="TCodeContent">{{storeLists.bankCard}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">开户银行：</span>
                        <span class="TCodeContent">{{storeList.bankName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">银行所属省：</span>
                        <span class="TCodeContent">{{storeLists.bankProvince}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode"> 银行所属市：</span>
                        <span class="TCodeContent">{{storeLists.bankCity}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">开户支行：</span>
                        <span class="TCodeContent">{{storeLists.bankBranchName}}</span>
                      </li>
                      <li class="TableContent" v-if="storeLists.bankType === 'P'">
                        <span class="TCode">持卡人身份证号：</span>
                        <span class="TCodeContent">{{storeLists.idCard}}</span>
                      </li>
                      <li class="TableContent" v-if="storeLists.bankType === 'C'">
                        <span class="TCode">统一社会信用代码：</span>
                        <span class="TCodeContent">{{storeLists.creditCode}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">持卡人手机号：</span>
                        <span class="TCodeContent">{{storeLists.bankTel}}</span>
                      </li>
                      <li class="clear"></li>
                    </ul>
                  </div>
                  <div style="height:46px;padding-top:16px;">
                    <a
                      class="btn btn-primary m-r-5"
                      style="float:right;cursor:pointer;color:#fff !important"
                      @click="Goback"
                    >返&nbsp;&nbsp;回</a>

                    <span class="clear"></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end panel -->
          </div>

          <!-- end col-10 -->
        </div>

        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "SelesDetail",
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      shopId: '',
      storeList: [],
      storeLists:[],
      recom_id:'',
      companyId:''
    };
  },
  mounted: function() {
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
    }
    if(this.$route.query.companyId){
      this.companyId = this.$route.query.companyId;
    }
    this.initdata();
  },
  methods: {
    Goback() {
      if(this.recom_id == ''){
        this.$router.push({ name: "StoreList", params: { pageNo : this.pageNo , pagesize:this.pageSize,searchContent: this.searchContent}});
      }else{
        this.$router.push({ name: "StoreList", query: {recomId: this.recom_id,companyId: this.companyId},params: { pageNo : this.pageNo , pagesize:this.pageSize,searchContent: this.searchContent}});
      }
    },
    initdata() {
      let that = this;
      if(localStorage.getItem('goodlist')){
        let goodlist = localStorage.getItem('goodlist');
        this.shopId = JSON.parse(goodlist).shopId;
        this.pageNo = JSON.parse(goodlist).pageNo;
        this.pageSize = JSON.parse(goodlist).pageSize;
        this.searchContent =  JSON.parse(goodlist).searchContent;
        const options = {
          url: "distribution/distribution/queryB2cO2oShopById",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            shopId:JSON.parse(localStorage.getItem('goodlist')).shopId
          })
        };
        axios(options).then(function(response) {
          if (response.data.code == 200) {
            that.storeList = response.data.data;
            that.storeLists = JSON.parse(response.data.data.accountData);
          } else {
              http.handleEorrorCode(response,that);
          }
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}

@media screen and (max-width:1360px){
  .TableContent {
    width: 50%;
  }
}
@media screen and (min-width:1360px) and (max-width:1680px){
  .TableContent {
    width: 50%;
  }
}
@media screen and (min-width:1680px){
  .TableContent {
    width: calc(100%/3);
  }
}
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  display: block;
  width: 145px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 145px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top: 8px;
  padding-bottom: 8px;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}
.tableAll,
.tableOne,
.tableSku {
  font-size: 14px;
  margin-bottom: 0;
}
.tableAll > tbody > tr > td {
  border: none;
  width: 25%;
  padding: 5px 15px;
}
.tableAll > tbody > tr {
  text-align: left;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;

}
.tableOne {
  border: 1px #e5e5e5 solid;
}
.tbheader {
  background: #f4f4f4;
  text-align: left;
}
.tbone {
  border: 1px #e5e5e5 solid;
}
.trbottom > td {
  border-bottom: none;
}
.tdprice {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreManage/StoreDetail.vue